import React from 'react';

import { ProductButtonProps } from '../../../../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';
import { useValidateSuitabilityInsideCustomerDetails } from '../../hooks/useValidateSuitabilityInsideCustomerDetails';

export const PublicOfferButton: React.FC<ProductButtonProps<'publicOffers'>> = (props) => {
  const { validateUserAvailability } = useValidateSuitabilityInsideCustomerDetails();

  const { available: customerHasAccess, message } = validateUserAvailability(
    props.offer.suitabilityProfile,
    props.offer.isQualified,
    props.offer.isProfessional
  );

  return (
    <ApplicationButton
      {...props}
      isDisabled={props.isDisabled || !customerHasAccess}
      idSelector="offerId"
      tooltip={message}
    />
  );
};
